import { BaseModal } from "./BaseModal";

export function ConfirmActionModal({
  isOpen = true,
  action,
  closeModal,
  heading,
  message,
  confirmButtonText,
}) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={closeModal}
      title={heading}
      footer={
        <>
          <button
            onClick={closeModal}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={action}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
          >
            {confirmButtonText}
          </button>
        </>
      }
    >
      <p className="text-sm text-gray-600">{message}</p>
    </BaseModal>
  );
}
